import { Header } from '../components/Header';
import { Layout, ContentWithMenu, Content, Box } from '../components/Layout';
import { Menu } from '../components/Menu';
import { Login } from '../pages/Login';
import { Loader } from '../components/Loader';

import { useAuthData } from './useAuthData';

import { Router } from './router/Router';

export const App = () => {
  const { user, loading } = useAuthData();

  return (
    <Loader loading={loading}>
      {user ? (
        <Layout>
          <Header />
          <ContentWithMenu>
            <Menu />
            <Content>
              <Box>
                <Router />
              </Box>
            </Content>
          </ContentWithMenu>
        </Layout>
      ) : (
        <Login />
      )}
    </Loader>
  );
};
